import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Observable } from "rxjs/Rx";
import { SxHttpService } from "./sxHttp.service";
import { StandardDictionary, OrganizationCategory } from "../model/interfaces/standarddictionary.interface";

@Injectable()
export class StandardDictionaryService {
    private serviceUrl = "api/standarddictionary";

    constructor(private http: Http, private sxHttp: SxHttpService) { }

    //#region standard dictionary persistence
    getAll(): Observable<StandardDictionary[]> {
        return this.sxHttp
            .get(this.serviceUrl + "/getall")
            .map((response) => response.json().data as StandardDictionary[]);
    }

    getCategory(): Observable<OrganizationCategory[]> {
        return this.sxHttp
            .get(this.serviceUrl + "/getorganizations")
            .map((response) => {
                return response.json().data as OrganizationCategory[];
            });
    }
    getById(id: string): Observable<StandardDictionary> {
        return this.sxHttp
            .get(this.serviceUrl + "/getbyid" + "/" + id)
            .map((response) => response.json().data as StandardDictionary);
    }
    create(model: StandardDictionary): Promise<any> {
        return this.sxHttp
            .post(this.serviceUrl + "/createorupdate", model)
            .toPromise()
            .then((response) => {
                return response.json().data;
            });
    }
    delete(id: string): Promise<Boolean> {
        return this.sxHttp
            .delete(this.serviceUrl + "/delete" + "/" + id)
            .toPromise()
            .then((result) => result.json().data);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/standarddictionary.service.ts